import React, { useState, useEffect } from 'react';
import { fetchApi } from '../../utils/api';

// Function to transform database data into component format
const transformVentureFundsData = (ventureFundsData) => {
  if (!ventureFundsData) return { companyData: {}, labelArrays: { logos: [] } };

  // Convert to array and sort by homepage_rank
  const sortedFunds = Object.entries(ventureFundsData)
    .map(([key, value]) => ({ key, ...value }))
    .sort((a, b) => a.homepage_rank - b.homepage_rank);

  // Create companyData object
  const companyData = {};
  const logoOrder = [];

  // Add sorted funds
  sortedFunds.forEach(fund => {
    companyData[fund.key] = {
      text: fund.text,
      logo: fund.logo
    };
    logoOrder.push(fund.key);
  });

  // Add Extra field at the end
  companyData.Extra = {
    text: "..and more"
  };
  logoOrder.push("Extra");

  return {
    companyData,
    labelArrays: {
      logos: logoOrder
    }
  };
};
  

const LogoWrap = ({ variant = 'logos', companyData = {}, labelArrays = {} }) => {
  const labels = labelArrays[variant] || [];

  return (
    <div className="logo-wrap">
      {labels.map((label, index) => (
        <span 
          key={`wrap-${index}`}
          className="label"
        >
          {companyData[label]?.logo && (
            <img 
              src={companyData[label].logo} 
              alt={`${label} logo`}
              className="logo-tag-image"
            />
          )}
          {companyData[label]?.text && (
            <span className="label-text">
              {companyData[label].text}
            </span>
          )}
        </span>
      ))}
    </div>
  );
};

 
       

function InvestorsIntro() {
  const [ventureFundsData, setVentureFundsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVentureFunds = async () => {
      try {
        setLoading(true);
        const response = await fetchApi('/api/public/website-inputs/', {
          method: 'GET',
          params: {
            name: 'homepage_venture_funds'
          }
        });
        
        if (response.data && response.data.length > 0) {
          setVentureFundsData(response.data[0].input_json);
        }
      } catch (error) {
        console.error('Error fetching venture funds data:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchVentureFunds();
  }, []);

  // Transform the data
  const { companyData, labelArrays } = transformVentureFundsData(ventureFundsData);

  if (loading) {
    return (
      <main>
        <section className="content-section">
          <div className="list-grid">
            <div className="list-item bold no-bullet">Adding Believers.</div>
          </div>
          <p className="list-grid-text">70%+ of teams have raised additional capital from exceptional investors.</p>
        </section>
        <section className="content-section">
          <div className="logo-wrap">
            <span className="label">Loading...</span>
          </div>
        </section>
        <section className="content-section">
          <div className="button-container">
            <a href="/investors" className="investor-network-button">Join LeapYear Investor Network →</a>
          </div>
        </section>
      </main>
    );
  }

  if (error) {
    return (
      <main>
        <section className="content-section">
          <div className="list-grid">
            <div className="list-item bold no-bullet">Adding Believers.</div>
          </div>
          <p className="list-grid-text">70%+ of teams have raised additional capital from exceptional investors.</p>
        </section>
        <section className="content-section">
          <div className="logo-wrap">
            <span className="label">Error loading investor data</span>
          </div>
        </section>
        <section className="content-section">
          <div className="button-container">
            <a href="/investors" className="investor-network-button">Join LeapYear Investor Network →</a>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main>
          <section className="content-section">
            <div className="list-grid">
              <div className="list-item bold no-bullet">Adding Believers.</div>
            </div>
            <p className="list-grid-text">70%+ of teams have raised additional capital from exceptional investors.</p>
          </section>
          <section className="content-section">
            <LogoWrap variant="logos" companyData={companyData} labelArrays={labelArrays} />
          </section>
          <section className="content-section">
            <div className="button-container">
              <a href="/investors" className="investor-network-button">Join LeapYear Investor Network →</a>
            </div>
          </section>
    </main>
  );
}

export default InvestorsIntro;
export { LogoWrap };